import { Outlet, RouteObject, useParams } from 'react-router'
import { ObjectTypes } from '../api/object'
import { useTableLayout } from '../layouts'
import { ObjectCreate } from './object-create'
import { ObjectEdit } from './object-edit'
import { Objects, ObjectsTable } from './objects'
import { Root } from './root'

export const OBJECTS_ROUTES: RouteObject = {
	path: ':object/*',
	element: <Root />,
	children: [
		{
			path: '',
			index: true,
			element: <Objects />,
		},
		{
			path: 'create',
			element: <ObjectCreate />,
		},
		{
			path: ':id',
			element: <Outlet />,
			children: [
				{
					index: true,
					element: <ObjectEdit />,
				},
				{
					path: ':relation',
					element: <RelatedObjects />,
				},
			],
		},
	],
}

function RelatedObjects() {
	const { id = '', object = '', relation = '' } = useParams()
	const { layout, isLoading } = useTableLayout(relation, object, {
		type: 'relation',
	})

	if (isLoading) return null
	if (!layout) return null

	return <ObjectsTable table={layout} object={relation} related={{ parent_id: id }} />
}
